import { createSlice } from "@reduxjs/toolkit";

const patientSlice = createSlice({
  name: "patient",
  initialState: {
    patId: "",
    patIdForOrder: "",
    patIdForRefill: "",
    orderList: [],
  },
  reducers: {
    updatePatId: (state, action) => {
      state.patId = action.payload;
    },
    clearPatId: (state, action) => {
      state.patId = "";
    },
    updatePatIdForOrder: (state, action) => {
      state.patIdForOrder = action.payload;
    },
    clearPatIdForOrder: (state, action) => {
      state.patIdForOrder = "";
    },
    updatePatIdForRefill: (state, action) => {
      state.patIdForRefill = action.payload;
    },
    clearPatIdForRefill: (state, action) => {
      state.patIdForRefill = "";
    },
    updateOrders: (state, action) => {
      state.orderList = action.payload;
    },
    clearOrders: (state, action) => {
      state.orderList = [];
    },
  },
});

export const selectPatId = (state) => {
  return state?.patient;
};

export const getPatId = (state) => {
  return {
    patId: state?.patient?.patId,
  };
};

export const getPatIdForOrders = (state) => {
  return {
    patId: state?.patient?.patIdForOrder,
  };
};
export const getPatIdForRefill = (state) => {
  return {
    patId: state?.patient?.patIdForRefill,
  };
};
export const getOrders = (state) => {
  return {
    orderList: state?.patient?.orderList,
  };
};

export const {
  updatePatId,
  clearPatId,
  updatePatIdForOrder,
  clearPatIdForOrder,
  updatePatIdForRefill,
  clearPatIdForRefill,
  updateOrders,
  clearOrders,
} = patientSlice.actions;

export default patientSlice.reducer;
